// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__21kXK","modal":"Modal_modal__1i-gD","slide-down":"Modal_slide-down__BNY2z","content":"Modal_content__16dcR"};